import {
  PairedSalesAnalysisFeature,
  StudiesPair,
  ToolkitStudyV1Request,
} from '@aloft/toolkit-shared';

import { isPairedSalesSqFtFeature } from '../types.js';
import { makeAdjustResult } from './makeAdjustResult.js';
import { makeSqFtFeatureAdjustResultAndFormulaString } from './makeSqFtFeatureAdjustResultAndFormulaString.js';

export function makeDifferenceString(
  pair: StudiesPair,
  reconciledValue: ToolkitStudyV1Request['body']['reconciledValue'],
  feature: PairedSalesAnalysisFeature,
): string {
  if (isPairedSalesSqFtFeature(feature)) {
    const { result } = makeSqFtFeatureAdjustResultAndFormulaString({
      feature,
      pair,
    });

    if (result.t === 'absolute') {
      return `${result.value.toString(true)}/sqft`;
    }
  }

  const adjustResult = makeAdjustResult(pair, reconciledValue, feature);

  return adjustResult.t === 'percent'
    ? `${adjustResult.value.toLocaleString()} %`
    : adjustResult.value.toString(true);
}
